module.exports = __webpack_public_path__ + "static/img/P-400-WHITE.b6cd9e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/P-400-WHITE.png
// module id = CiTz
// module chunks = 0